import "../assets/css/style.css";
import "../assets/js/light-bootstrap-dashboard.js";

export function showHideLoadingDiv(showHideLoadingDiv: boolean) {
    if (showHideLoadingDiv)
        document.getElementById("loadingDiv") && document.getElementById("loadingDiv").setAttribute("style", "display: block");
    else
        document.getElementById("loadingDiv") && document.getElementById("loadingDiv").setAttribute("style", "display: none");
}


// WEBPACK FOOTER //
// ./src/loaders/StyleLoader.ts